import React from 'react';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import Tooltip from '@frontend/jetlend-web-ui/src/ui/TooltipIcon/Tooltip';
import Image from '@app/components/Image/Image';
import styles from './CourseHeaderBadge.module.scss';

interface IProps {
    /**
     * текст/значение баджа
     */
    value: string|number;
    /**
     * размер баджа
     */
    size?: 'default'|'small';
    /**
     * иконка ачивки
     */
    achievementIcon: string;
    /**
     * Название ачивки
     */
    achievementName: string;
}

/**
 * Компонент отрисовывает бадж ачивок
 */
const AchievementHeaderBadge = (props: IProps) => {
    const {
        value,
        size = 'default',
        achievementIcon,
        achievementName,
    } = props;

    const badgeClassName = buildClassNames(styles, [
        'container',
        `container--${size}`,
    ]);

    return (
        <Tooltip title={achievementName}>
            <div className={badgeClassName}>
                <div className={styles['text']}>
                    {value}
                </div>
                <div className={styles['icon']}>
                    <Image src={achievementIcon} fill alt="" />
                </div>
            </div>
        </Tooltip>
    );
};

export default AchievementHeaderBadge;
